import { FixedSizeList } from 'react-window'
import { ListItemButton, ListItem, ListItemText } from '@mui/material'


export default function VirtualizedList({ items, keyLibelle, onItemClick, selectedItem }) {

  function renderRow(props) {
    const { index, style } = props
  
    return (
      <ListItem style={style} key={index} component="div" disablePadding>
        <ListItemButton onClick={() => onItemClick(items[index])} selected={items[index] == selectedItem}>
          <ListItemText primary={items[index][keyLibelle]} />
        </ListItemButton>
      </ListItem>
    )
  }

  if (!items || items.length === 0) return <></>

  return (
    <FixedSizeList
      height={530}
      itemSize={46}
      itemCount={items.length}
      overscanCount={5}
      className='VirtualizedList'
    >
      {renderRow}
    </FixedSizeList>
  )
}